import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Home, MessageCircle } from "lucide-react";
import { clinicInfo } from "../mock/data";

export default function NotFound({ code = 404, title, message }) {

  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    const previousRobots = robots?.getAttribute("content");
    const previousTitle = document.title;

    document.title = "Page Not Found | Dr. Khurana's Dental Clinic";
    if (robots) robots.setAttribute("content", "noindex, nofollow");

    return () => {
      document.title = previousTitle;
      if (robots && previousRobots) {
        robots.setAttribute("content", previousRobots);
      }
    };
  }, []);

  useEffect(() => { document.title = `${code} — Dr. Khurana's Dental Clinic`; window.scrollTo(0, 0); }, [code]);

  const isServer = code >= 500;
  const heading = title || (isServer ? "Something went wrong" : "Page not found");
  const desc = message || (isServer
    ? "We hit an unexpected snag on our side. Please try again in a moment or call the clinic directly."
    : "The page you're looking for doesn't exist, or has been moved. Let's get you back to a helpful page.");

  return (
    <div className="min-h-screen bg-[#f6f7f4] flex items-center justify-center px-6">
      <div className="max-w-[720px] w-full text-center">
        <div className="font-serif-display text-[120px] md:text-[180px] leading-none text-[#14a68e]">
          {String(code).slice(0,1)}<span className="italic-serif text-[#0e2b2b]">{String(code).slice(1)}</span>
        </div>
        <div className="mt-2 text-[11px] tracking-[0.32em] uppercase text-[#14a68e] font-semibold">Dr. Khurana&rsquo;s Dental &amp; Aesthetic Clinic</div>
        <h1 className="mt-6 font-serif-display text-[36px] md:text-[54px] leading-tight text-[#0e2b2b]">{heading}</h1>
        <p className="mt-5 text-[15px] md:text-[16px] text-[#0e2b2b]/70 max-w-[520px] mx-auto">{desc}</p>

        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary"><Home size={16} /> Back to Home <ArrowRight size={16} /></Link>
          <Link to="/blog" className="btn-ghost">Read the Blog <ArrowRight size={16} /></Link>
          <a href={clinicInfo.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost"><MessageCircle size={16} /> Ask on WhatsApp</a>
        </div>

        <button onClick={() => window.history.length > 1 && window.history.back()} className="mt-8 inline-flex items-center gap-2 text-[13px] text-[#0e2b2b]/60 hover:text-[#0e2b2b] transition">
          <ArrowLeft size={14} /> Go back to the previous page
        </button>
      </div>
    </div>
  );
}
